import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures hash links (e.g. /#how, /#pricing) scroll to the target element
 * after a route change, since React Router doesn't trigger native hash-scroll.
 * Also resets scroll-to-top when navigating between pages without a hash.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Give the new route a tick to mount its sections
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 80);
      return () => clearTimeout(t);
    }
    // No hash → scroll to top on route change
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
